import React, { useEffect, useState } from "react";
import {Form, Row, Col, Button} from "react-bootstrap";
import { ninjas } from "../data/relics";

const NinjaSelection = (props) => {

    const [ninjaName, setNinjaName] = useState(ninjas[0].name);

    useEffect(() => {
        if (props.ninja)
        {
            setNinjaName(props.ninja.name);
        }
    });

    const handleClear = () => {
        props.setRelics([null, null, null, null, null]);
    };

    const handleSetNinja = (e) => {
        let index;
        let name = e.target.value;
        for (let i = 0, len = ninjas.length; i < len; i++)
        {
            let ninja = ninjas[i];
            if (name === ninja.name)
            {
                index = i;
            }
        }
        setNinjaName(name);
        props.setSelectedNinja(ninjas[index]);
    };

    return (
        <Form className="p-1 ">
            <Row className="pb-2">
                <Col>
                    <Form.Select style={{width: '100px'}} size={"sm"} value={ninjaName} onChange={(e) => handleSetNinja(e)}>
                        {
                            ninjas.map((ninja, index) => {
                                return <option key={index} value={ninja.name} data-ninja={ninja}>{ninja.name}</option>
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
            
            <Row>
                <Col className={'1' === props.side ? "d-flex justify-content-end" :  "d-flex justify-content-start"}>
                    <Button variant="outline-danger" size="sm" onClick={handleClear}>Clear</Button>
                </Col>
            </Row>
        </Form>
    );
};

export default NinjaSelection;